import { BaseCriterionSchemaProcessor } from './base-criterion-schema-processor';

export class LocationCriterionSchemaProcessor extends BaseCriterionSchemaProcessor {
  constructor(options) {
    super(options, ['Criterion/Webpage/Parameter/CriterionName']);
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    const locationNameOption = updatedSchema.properties.CriterionWebpageParameterCriterionName;
    if (locationNameOption) {
      locationNameOption.property = 'Criterion/Name';
    }

    if (this.Permissions.IsPersonalizedOffersEnabled &&
        !this.Permissions.IsPersonalizedOffersV3Enabled) {
      updatedSchema.properties.CriterionCashback = {
        filterable: true,
        type: 'number',
        minimum: 0,
        maximum: 50,
        required: true,
      };
    }

    return updatedSchema;
  }
}
